import { StorageKeyPerformanceEnum } from '@core/storage/types'

export const FWREFERRER_KEY = StorageKeyPerformanceEnum.fw_attr_ref
